import React, { useState, useEffect } from "react";
import { Button, Form } from "react-bootstrap";
import Select from 'react-select';
import imgCamelLogo from '../../assets/images/main-logo-white.png';
import "./EditUserRoleForm.scss";

const EditUserRoleForm = props => {
  const [role, setRole] = useState('');
  const [error, setError] = useState(null);

  const onChangeRole = (value) => {
    setRole(value.value);
  }

  useEffect(() => {
    if (props.user) {
      setRole(props.user.role);
    }
  }, [props.user]);

  const onSubmit = (e) => {
    e.preventDefault();

    if (!role || role === '') {
      setError('Please select user role.');
      return;
    }

    props.updateUserRole(
      props.user.userId,
      {
        name: 'role',
        value: role,
        email: props.user.email,
        userId: props.user.userId
      }
    );

    props.onClose();
  }

  return (
    <div className="change-user-role-form">
      <div className="form-header">
        <img src={imgCamelLogo} alt="logo" />
      </div>
      <div className="p-4">
        <h3>Change User Role</h3>
        <Form onSubmit={onSubmit}>
          <Select
            options={[
              { value: 'admin', label: 'Admin' },
              { value: 'user', label: 'User' }
            ]}
            placeholder="Select Role"
            onChange={onChangeRole}
            size={16}
            value={{ value: role, label: role }}
          />
          {error && <div className="mt-2" style={{ color: 'red' }}>{error}</div>}
          <div className="actions-box mt-4">
            <Button variant="outline-danger" className="ml-2" size="sm" onClick={props.onClose}>CANCEL</Button>
            <Button type="submit" variant="outline-danger" className="ml-2" size="sm">CHANGE</Button>
          </div>
        </Form>
      </div>
    </div>
  )
}

export default EditUserRoleForm;
